import {Injectable} from "@angular/core";
import {Observable} from "rxjs/Observable";
import "rxjs/add/observable/of";
import "rxjs/add/operator/do";
import "rxjs/add/operator/delay";
import {Agency} from "../../model/agency";
import {LocalStorageService} from "ngx-webstorage";

@Injectable()
export class AuthService {
  isLoggedIn: boolean = false;
  timeStamp: number;
  agency: Agency;
  mapRadius: number;

  // store the URL so we can redirect after logging in
  redirectUrl: string;

  constructor(private storage: LocalStorageService) {
    if (!this.agency)this.agency = this.storage.retrieve('agency');
    this.isLoggedIn = this.storage.retrieve('isLoggedIn');
    this.timeStamp = this.storage.retrieve('timeStamp');
  }

  saveValue(key: string, value: any) {
    this.storage.store(key, value);
  }

  getValueForKey(key) {
    return this.storage.retrieve(key);
  }

  updateLogin(f: any, agency: Agency): Observable<boolean> {
    return Observable.of(true).delay(300).do(() => {
        this.isLoggedIn = f;
        this.timeStamp = (new Date()).getTime();
        this.agency = agency;
      this.saveValue('isLoggedIn', this.isLoggedIn);
      this.saveValue('timeStamp', this.timeStamp);
      this.saveValue('agency', agency);

      }
    );
  }


}

